export const URL_TERMS_OF_SERVICE   = '/terms-of-service';
export const URL_PRIVACY_POLICY     = '/privacy-policy';

export const URL_SIGN_IN            = '/sign-in?plan&subscription';
export const URL_SIGN_UP            = '/sign-up?plan&subscription';
export const URL_PAYMENT            = '/payment/:plan/:subscription';



// WEBPACK FOOTER //
// ./src/common/state/index.js